import React, { useState, useEffect } from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
} from "@mui/material";

export default function RadioGroupSelect({
  label = "Select option",
  options = [],             // [{label: "A", value: "a"}, ...]
  initialSelected = "",     // fx "a"
  onChange,                 // callback(selectedValue)
  disabled = false,         // disable hele gruppen
  isOptionDisabled,         // (value) => true/false
}) {
  const [selected, setSelected] = useState(initialSelected);

  // Sync hvis initialSelected ændrer sig udefra
  useEffect(() => {
    setSelected(initialSelected);
  }, [initialSelected]);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelected(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <Box>
      <FormControl component="fieldset">
        {label && <FormLabel component="legend">{label}</FormLabel>}
        <RadioGroup value={selected} onChange={handleChange}>
          {options.map((opt) => (
            <FormControlLabel
              key={opt.value}
              value={opt.value}
              control={<Radio />}
              label={opt.label}
			  disabled={disabled || (isOptionDisabled?.(opt.value) ?? false)}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
}